export default __webpack_public_path__ + "static/media/newwallet.e0e7a6d5.png";